import { render } from "./screenTree.vue?vue&type=template&id=eff1971e&scoped=true"
import script from "./screenTree.vue?vue&type=script&lang=js"
export * from "./screenTree.vue?vue&type=script&lang=js"

import "./screenTree.vue?vue&type=style&index=0&id=eff1971e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff1971e"]])

export default __exports__